export class SessionToken
{
  token: string;
}
